import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

export const BaggageHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión de Equipajes y Excesos"
    text="Éste es el módulo de Gestión de Equipajes y Excesos."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ BaggageUnit }) => ({
  cards: BaggageUnit.UnitHome.get('cards'),
  breadcrumbs: BaggageUnit.UnitHome.get('breadcrumbs'),
});

BaggageHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(BaggageHome);
